import React, { useState } from "react";
import { useAppSelector } from "@litres-core/store";
import cn from "classnames";
import { ProfileButton } from "../ProfileButton";
import styles from "./Profile.module.scss";

const Profile = (): JSX.Element => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const {
    id: userID,
    profile: userProfile,
    settings: userSettings,
    subscription: { is_active: isActiveSubscription },
  } = useAppSelector(state => state.foundationUser);

  const isPDA = useAppSelector(state => state.browser.pda);

  const isShowUserAvatar = Boolean(
    (userSettings.profile_privacy === "public" ||
      userSettings.profile_privacy === "default") &&
      userProfile.avatar_url &&
      userProfile.avatar_url.length > 0
  );

  const handleProfileClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    setLoading(true);
  };

  return (
    <div
      className={cn(styles.wrapper, { [styles.wrapperOnLoading]: isLoading })}
      onClick={handleProfileClick}
    >
      <ProfileButton
        href="/me/profile/"
        id={+userID}
        size={48}
        hasAvatar={isShowUserAvatar}
        isGradient={Boolean(isActiveSubscription)}
        isPDA={isPDA}
      />
    </div>
  );
};

export default Profile;
